import {Component, TextComponent} from '@wonderlandengine/api';
import {user} from '@wonderlandengine/uber-sdk';

/**
 * welcome-message
 */
export class WelcomeMessage extends Component {
    static TypeName = 'welcome-message';

    /* Properties that are configurable in the editor */

    start() {
        const t = this.object.getComponent(TextComponent)!;
        t.text = `Welcome, ${user.user?.name ?? '<name missing>'}!`;
    }
}
